/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Functional role of the contact within the member club.
 */
export type FederationMemberRole = (typeof FederationMemberRole)[keyof typeof FederationMemberRole];

export const FederationMemberRole = {
  president: "president",
  vicePresident: "vicePresident",
  boardMember: "boardMember",
  secretaryGeneral: "secretaryGeneral",
  chiefExecutiveOfficer: "chiefExecutiveOfficer",
  treasurer: "treasurer",
  executiveDirector: "executiveDirector",
  technicalDirector: "technicalDirector",
  operationsManager: "operationsManager",
  competitionManager: "competitionManager",
  committeeChair: "committeeChair",
  committeeMember: "committeeMember",
  athleteRepresentative: "athleteRepresentative",
  clubRepresentative: "clubRepresentative",
  generalAssemblyMember: "generalAssemblyMember",
  votingMember: "votingMember",
  officiatingManager: "officiatingManager",
  coachingManager: "coachingManager",
} as const;
